<template>
  <el-popover
    width="150"
    popper-class="select-staff-popover"
    ref="selectStaffPopover"
    trigger="manual"
    v-model="visible"
  >
    <div style="height: 200px" v-ps ref="userWrapper" @ps-y-reach-end="showMore">
      <div v-for="(user, index) in userForShow" :key="index" class="user" @click="setUser(user)">
        <staff-popover :staffId="user.id">
          <template v-slot:reference>
            <staff-avatar class="avatar" :size="20" :user="user"></staff-avatar>
          </template>
        </staff-popover>
        <span style="margin-left: 10px" v-tip>{{ user.nameNew }}</span>
      </div>
    </div>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>
<script>
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import StaffAvatar from "@/components/StaffAvatar"
export default {
  name: "select-staff-popover",
  components: { StaffAvatar, StaffPopover },
  props: {
    visible: Boolean,
    users: Array
  },
  data() {
    return {
      showCount: 20
    }
  },
  computed: {
    userForShow() {
      return this.users.slice(0, this.showCount)
    }
  },
  methods: {
    changePosition(position) {
      let selectStaffPopover = this.$refs.selectStaffPopover
      selectStaffPopover.$refs.popper.style.left = position.left - 60 + "px"
      selectStaffPopover.$refs.popper.style.top = position.top - 220 + "px"
    },
    setUser(user) {
      this.$emit("liftUser", user)
    },
    showMore() {
      if (!this.$refs.userWrapper?.clientHeight) return // 此时是处于隐藏状态
      this.showCount = Math.min(this.users.length, this.showCount + 10)
    }
  }
}
</script>

<style lang="scss">
.select-staff-popover.el-popover {
  padding: 10px;
  z-index: 1000;
  min-width: unset;
  .user {
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 4px;
    .avatar {
      font-size: 12px;
    }
    &:hover {
      background-color: #e7eaee;
    }
  }
}
</style>
